export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "Personal information refers to any data that can identify an _____ individual.",
    "description": "identifiable"
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "True/False: Logging access to personal data supports both security monitoring and privacy accountability.",
    "description": "True"
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What is the purpose of a data retention schedule?",
    "description": "To define how long personal data is stored and when it should be archived or destroyed."
  },
  {
    "id": 4,
    "topic_id": 2,
    "title": "A Privacy Impact Assessment is performed to evaluate privacy _____ associated with a system or process.",
    "description": "risks"
  },
  {
    "id": 5,
    "topic_id": 3,
    "title": "True/False: Fully anonymized data is exempt from privacy obligations only if re-identification is not reasonably possible.",
    "description": "True"
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What is the role of a privacy governance structure?",
    "description": "To define accountability, responsibilities, and oversight for privacy-related activities."
  },
  {
    "id": 7,
    "topic_id": 4,
    "title": "Data classification helps determine appropriate _____ based on data sensitivity.",
    "description": "controls or safeguards"
  },
  {
    "id": 8,
    "topic_id": 4,
    "title": "True/False: APIs can introduce privacy risk when they expose personal data without proper access controls.",
    "description": "True"
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What is a privacy metric?",
    "description": "A measurable indicator used to assess privacy program performance or compliance."
  },
  {
    "id": 10,
    "topic_id": 4,
    "title": "Differential privacy adds statistical _____ to data outputs to protect individuals.",
    "description": "noise"
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "True/False: Transparency requires organizations to communicate data processing practices clearly.",
    "description": "True"
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "Data minimization means collecting only the _____ amount of data necessary.",
    "description": "minimum"
  },
  {
    "id": 13,
    "topic_id": 4,
    "title": "What is the purpose of identity and access management?",
    "description": "To ensure that only authorized users have access to personal data."
  },
  {
    "id": 14,
    "topic_id": 2,
    "title": "True/False: Privacy training helps reduce risk by increasing awareness of data-handling obligations.",
    "description": "True"
  },
  {
    "id": 15,
    "topic_id": 3,
    "title": "A dataset used for analytics contains outdated information. Which data quality principle is violated?",
    "description": "Accuracy"
  },
  {
    "id": 16,
    "topic_id": 4,
    "title": "Secure development lifecycle integrates privacy and security _____ into software development.",
    "description": "controls"
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "True/False: Vendor risk management should include evaluation of privacy practices.",
    "description": "True"
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What is the purpose of privacy frameworks?",
    "description": "To provide structured guidance for building and evaluating privacy programs."
  },
  {
    "id": 19,
    "topic_id": 4,
    "title": "Aggregating data reduces risk by removing individual-level _____.",
    "description": "detail"
  },
  {
    "id": 20,
    "topic_id": 4,
    "title": "True/False: Cookie management tools can be used to implement consent preferences.",
    "description": "True"
  },
  {
    "id": 21,
    "topic_id": 4,
    "title": "What is privacy by design?",
    "description": "Integrating privacy considerations into systems and processes from the outset."
  },
  {
    "id": 22,
    "topic_id": 4,
    "title": "Logs containing user identifiers should be protected because they can enable _____ attacks.",
    "description": "linkage"
  },
  {
    "id": 23,
    "topic_id": 3,
    "title": "True/False: Data destruction must ensure that information cannot be reconstructed.",
    "description": "True"
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "Risk response can include mitigation, acceptance, transfer, or _____.",
    "description": "avoidance"
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What privacy risk is associated with unsecured endpoints?",
    "description": "Unauthorized access to stored personal data."
  },
  {
    "id": 26,
    "topic_id": 1,
    "title": "True/False: Incident management should include privacy impact evaluation.",
    "description": "True"
  },
  {
    "id": 27,
    "topic_id": 3,
    "title": "A data inventory documents where personal data is _____.",
    "description": "stored"
  },
  {
    "id": 28,
    "topic_id": 4,
    "title": "What is pseudonymization?",
    "description": "Replacing identifiers with other values to prevent re-identification."
  },
  {
    "id": 29,
    "topic_id": 2,
    "title": "True/False: Evidence and artifacts support privacy compliance verification.",
    "description": "True"
  },
  {
    "id": 30,
    "topic_id": 3,
    "title": "Consent must be freely given, specific, informed, and _____.",
    "description": "unambiguous or clear"
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "What is the purpose of data archiving?",
    "description": "To store data long-term with reduced operational access."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "True/False: Encryption protects the confidentiality of personal data.",
    "description": "True"
  },
  {
    "id": 33,
    "topic_id": 2,
    "title": "What is a privacy threat?",
    "description": "A potential cause of unauthorized disclosure or misuse of personal data."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "Cloud-native services require proper configuration to avoid data _____.",
    "description": "exposure, compromise, or loss"
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "True/False: Data subject rights include access and deletion requests.",
    "description": "True"
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "What is data use limitation?",
    "description": "Restricting data processing to defined purposes."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "Federated learning helps privacy by keeping data _____.",
    "description": "local"
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "Monitoring privacy controls supports continuous _____.",
    "description": "compliance"
  },
  {
    "id": 39,
    "topic_id": 1,
    "title": "True/False: Policies are part of privacy documentation.",
    "description": "True"
  },
  {
    "id": 40,
    "topic_id": 3,
    "title": "What is data destruction?",
    "description": "Securely eliminating data so it cannot be recovered."
  },
  {
    "id": 41,
    "topic_id": 4,
    "title": "Hashing supports data integrity by producing a fixed-length _____.",
    "description": "digest"
  },
  {
    "id": 42,
    "topic_id": 4,
    "title": "True/False: Vulnerability assessments identify weaknesses in privacy controls.",
    "description": "True"
  },
  {
    "id": 43,
    "topic_id": 4,
    "title": "What is the role of connectivity security?",
    "description": "Protect data during transmission between systems."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "Vendor contracts should specify privacy _____ requirements.",
    "description": "protection or assurance"
  },
  {
    "id": 45,
    "topic_id": 4,
    "title": "True/False: Data classification informs access control decisions.",
    "description": "True"
  },
  {
    "id": 46,
    "topic_id": 3,
    "title": "What is consent tagging?",
    "description": "Recording user consent preferences for data processing."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "Privacy dashboards often use key performance _____.",
    "description": "indicators"
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "True/False: Privacy laws define obligations for handling personal data.",
    "description": "True"
  },
  {
    "id": 49,
    "topic_id": 3,
    "title": "What is data disclosure?",
    "description": "Sharing personal data with another party."
  },
  {
    "id": 50,
    "topic_id": 1,
    "title": "Monitoring and logging enable _____ detection.",
    "description": "incident"
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "True/False: Risk mitigation reduces likelihood or impact.",
    "description": "True"
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "What is the purpose of SDLC privacy reviews?",
    "description": "To identify privacy risks during development."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "Organizational roles define privacy _____.",
    "description": "accountability"
  },
  {
    "id": 54,
    "topic_id": 2,
    "title": "True/False: Data analytics can increase privacy risk if improperly controlled.",
    "description": "True"
  },
  {
    "id": 55,
    "topic_id": 4,
    "title": "What is anonymization?",
    "description": "Irreversibly removing identifying information."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "Compliance reviews evaluate adherence to _____.",
    "description": "requirements, policies, or regulations"
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "True/False: Consent is always required for processing personal data.",
    "description": "False. Consent is not required when appropriate legal obligations, legitimate interests, or vital interests prevail."
  },
  {
    "id": 58,
    "topic_id": 3,
    "title": "What is data retention?",
    "description": "Maintaining data for a defined period."
  },
  {
    "id": 59,
    "topic_id": 4,
    "title": "IAM enforces least _____ access.",
    "description": "privilege"
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "True/False: Risk acceptance means that no controls are implemented.",
    "description": "False. A risk can be accepted for an existing control."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "What risk arises from insecure APIs?",
    "description": "Unauthorized data access."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "Privacy incident response includes _____.",
    "description": "notification"
  },
  {
    "id": 63,
    "topic_id": 3,
    "title": "True/False: Data quality affects decision-making accuracy.",
    "description": "True"
  },
  {
    "id": 64,
    "topic_id": 4,
    "title": "What is a PET?",
    "description": "(Privacy enhancing technology) Technology designed to protect privacy during data processing."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "Evidence demonstrates control _____.",
    "description": "effectiveness"
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "True/False: Privacy documentation includes guidelines.",
    "description": "True"
  },
  {
    "id": 67,
    "topic_id": 3,
    "title": "What is data transfer?",
    "description": "Moving data between locations or organizations."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "Encryption keys must be securely _____.",
    "description": "managed or protected"
  },
  {
    "id": 69,
    "topic_id": 2,
    "title": "True/False: Privacy training supports compliance culture.",
    "description": "True"
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "What is endpoint hardening?",
    "description": "Reducing the attack surface on devices."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "Data subject requests must be handled _____.",
    "description": "promptly or properly"
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "True/False: Data inventory supports data minimization.",
    "description": "True"
  },
  {
    "id": 73,
    "topic_id": 3,
    "title": "What are tracking technologies?",
    "description": "Tools used to identify, track, or monitor users and devices across sessions, sites, or applications."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "Program monitoring evaluates _____.",
    "description": "performance"
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "True/False: Personal information can include indirect identifiers.",
    "description": "True"
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What is secure deletion?",
    "description": "Overwriting or destroying data to prevent recovery."
  },
  {
    "id": 77,
    "topic_id": 4,
    "title": "Logs should be protected against _____.",
    "description": "tampering"
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "True/False: Threat identification is not a part of risk management.",
    "description": "False. Risk management does include threat and vulnerability identification."
  },
  {
    "id": 79,
    "topic_id": 4,
    "title": "What is cloud misconfiguration?",
    "description": "Incorrect settings that expose data."
  },
  {
    "id": 80,
    "topic_id": 4,
    "title": "True/False: Anonymization eliminates the ability to re-identify individuals when properly implemented.",
    "description": "True"
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "Privacy principles often emphasize fairness, accountability, and _____.",
    "description": "transparency"
  },
  {
    "id": 82,
    "topic_id": 4,
    "title": "What is the primary purpose of data classification in privacy programs?",
    "description": "To categorize data by sensitivity to determine appropriate protection measures."
  },
  {
    "id": 83,
    "topic_id": 2,
    "title": "True/False: A privacy-focused risk assessment should consider both likelihood and impact.",
    "description": "True"
  },
  {
    "id": 84,
    "topic_id": 4,
    "title": "Logging administrative access to systems containing personal data helps detect _____.",
    "description": "privilege misuse"
  },
  {
    "id": 85,
    "topic_id": 1,
    "title": "Data retention policies should align with legal and _____ requirements.",
    "description": "business"
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "What is the purpose of vendor privacy due diligence?",
    "description": "To evaluate third-party data-handling practices and risks."
  },
  {
    "id": 87,
    "topic_id": 2,
    "title": "True/False: Metrics can be used to demonstrate continuous improvement of privacy controls.",
    "description": "True"
  },
  {
    "id": 88,
    "topic_id": 4,
    "title": "Secure APIs should implement authentication and _____ controls.",
    "description": "authorization"
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "Combining multiple datasets increases the risk of _____.",
    "description": "re-identification"
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "True/False: Privacy laws establish obligations for protecting personal information.",
    "description": "True"
  },
  {
    "id": 91,
    "topic_id": 3,
    "title": "What is the goal of consent management platforms?",
    "description": "To capture and enforce user consent preferences."
  },
  {
    "id": 92,
    "topic_id": 2,
    "title": "Risk mitigation aims to reduce risk to an acceptable _____.",
    "description": "level"
  },
  {
    "id": 93,
    "topic_id": 3,
    "title": "True/False: Data destruction should include verification that data is unrecoverable.",
    "description": "True"
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "What is the purpose of encryption in transit?",
    "description": "To protect data from interception during transmission."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "Privacy incident response plans define roles and _____.",
    "description": "responsibilities"
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "True/False: Compliance artifacts can include policies, logs, and training records.",
    "description": "True"
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What privacy concern arises from unmanaged endpoints?",
    "description": "Unauthorized access or leakage of personal data."
  },
  {
    "id": 98,
    "topic_id": 3,
    "title": "Data quality includes completeness, accuracy, and _____.",
    "description": "consistency"
  },
  {
    "id": 99,
    "topic_id": 1,
    "title": "True/False: Transparency requires organizations to disclose the purposes of data processing.",
    "description": "True"
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "Applying differential privacy to aggregated analytics helps prevent _____.",
    "description": "individual inference"
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Understand the purpose of privacy governance.",
    "description": "Privacy governance provides structure, oversight, and accountability for how personal information is collected, used, protected, and managed. It ensures alignment with business objectives, regulatory requirements, and stakeholder expectations."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Know the components of a privacy program.",
    "description": "A privacy program includes policies, standards, procedures, controls, metrics, and reporting mechanisms that collectively govern the collection, handling, and protection of personal information. These components must be applied consistently and reviewed regularly."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Understand the definition and scope of personal information.",
    "description": "Personal information refers to data that identifies or can be linked to an individual, directly or indirectly. Definitions vary across laws, but generally include identifiers, sensitive attributes, and contextual data."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Understand the key privacy principles.",
    "description": "Core principles such as privacy by design, transparency, consent, purpose limitation, and data minimization guide responsible data handling. These principles translate legal and ethical expectations into operational practices."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Understand lawful bases for processing personal data.",
    "description": "Under regulations such as GDPR, processing must be justified by a lawful basis (e.g., consent, contract, legal obligation, legitimate interests). Consent is only one option and must meet strict requirements when used."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Recognize the role of governance structures and accountability.",
    "description": "Effective privacy governance includes clearly defined roles such as data owners, privacy officers, and oversight bodies. Models such as the three lines of defense help ensure accountability and independent assurance."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Understand the role of privacy documentation and records.",
    "description": "Documentation such as policies, notices, risk registers, and decision logs provides evidence of compliance and supports consistent operations. Records must be maintained, current, and aligned with regulatory expectations."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand organizational roles and responsibilities.",
    "description": "Privacy operations require clearly defined roles across functions, including privacy, legal, security, IT, and business units, with documented accountability and reporting structures."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Recognize the importance of vendor and supply chain oversight.",
    "description": "Organizations must perform up-front due diligence, establish contractual protections, and implement ongoing monitoring to manage third-party privacy risks."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Identify key components of privacy incident management.",
    "description": "Effective incident management includes detection, escalation, investigation, containment, notification, and post-incident review aligned with legal and regulatory requirements. Metrics help measure performance and identify opportunities for improvement."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand data subject rights handling processes.",
    "description": "Organizations must implement procedures for receiving, authenticating, tracking, and responding to data subject requests (DSRs) within required timeframes."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Apply data minimization and purpose limitation principles.",
    "description": "Personal data collection, use, and retention should be limited to what is necessary for defined, legitimate purposes to reduce risk and support compliance."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Ensure integration of privacy operations into business processes.",
    "description": "Privacy controls and procedures must be embedded into daily operations, systems, and workflows to ensure consistent and scalable program execution."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand the privacy risk management lifecycle.",
    "description": "Risk management is a continuous, iterative process that includes identifying, analyzing, evaluating, treating, and monitoring risks associated with personal data."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Distinguish key risk concepts.",
    "description": "Risk is the combination of likelihood and impact; threats are potential harmful events; vulnerabilities are weaknesses that can be exploited."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Know the primary risk treatment options.",
    "description": "Organizations respond to risk through acceptance, mitigation, transfer, or avoidance, based on cost, impact, and alignment with risk appetite."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Understand the purpose of PIAs and DPIAs.",
    "description": "These assessments evaluate how systems or process changes affect personal data and identify risks to individuals’ rights and freedoms."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Recognize the importance of asset, threat, and vulnerability analysis.",
    "description": "Effective risk assessments depend on identifying valuable data assets, realistic threat scenarios, and relevant vulnerabilities."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Understand governance, ownership, and monitoring.",
    "description": "Risks must be assigned to accountable owners, decisions must align with the organization’s risk appetite, and risks must be continuously monitored for changes."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Understand the purpose of privacy frameworks.",
    "description": "Privacy frameworks provide structure for privacy governance, controls, and operational processes. Organizations typically adapt one or more frameworks to align with regulatory requirements, business objectives, and risk tolerance rather than creating a program and controls from scratch."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Recognize the role of evidence and artifacts.",
    "description": "Evidence and artifacts demonstrate that privacy controls and processes exist and operate effectively. Examples include policies, data inventories, PIAs, consent records, DSR logs, incident reports, and governance meeting documentation used during audits and compliance assessments."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Understand the characteristics of effective metrics.",
    "description": "Privacy metrics should follow SMART principles: specific, measurable, attainable, relevant, and timely. Metrics should also be tailored to the intended audience and evaluated over time to identify meaningful trends in program performance."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Differentiate between KPIs, KRIs, KGIs, and KCIs.",
    "description": "KPIs measure operational performance, KRIs indicate risk exposure, KGIs measure progress toward strategic objectives, and KCIs evaluate the effectiveness of controls. Together, these indicators provide layered visibility into the effectiveness of privacy programs."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Understand categories of privacy program metrics.",
    "description": "Common metric categories include risk management, performance, convergence, and resource management. Each category provides insight into different aspects of privacy governance and operational effectiveness."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Recognize the purpose and types of privacy audits.",
    "description": "Privacy audits evaluate controls, processes, and compliance with policies or regulations. Types include operational, information systems, integrated, administrative, compliance, forensic, and service provider audits."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Understand the role of monitoring privacy responsibilities.",
    "description": "Ongoing monitoring activities, such as metrics reporting, internal audits, performance evaluation, and benchmarking, help organizations confirm that personal information is properly collected, used, protected, and disposed of in accordance with policy and regulations."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Understand the role of data inventory in privacy management.",
    "description": "A data inventory catalogs personal data assets, including their sources, locations, owners, purposes, and retention requirements. It enables organizations to understand what data exists and supports compliance, risk assessments, and data lifecycle controls."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Recognize how data flow diagrams support transparency and risk identification.",
    "description": "Data flow diagrams visually depict how data moves between systems, users, and third parties. They help identify collection points, processing activities, transfers, and storage locations, which are essential for assessing privacy risks and implementing controls."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Distinguish data provenance, data lineage, and records of processing activities (ROPA).",
    "description": "Data provenance documents the origin of data and how it was created or obtained. Data lineage traces the movement and transformation of data across systems throughout its lifecycle. ROPA provides a regulatory-focused record detailing processing purposes, data categories, recipients, retention, and safeguards. Together, these artifacts provide complementary visibility: provenance establishes source integrity, lineage shows operational flow and transformations, and ROPA documents compliance with privacy processing requirements."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Apply data classification to align protection with data sensitivity.",
    "description": "Data classification categorizes data based on sensitivity, regulatory requirements, and business impact. Classification informs handling requirements such as access controls, encryption, retention, and monitoring."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Ensure data quality as a foundational privacy requirement.",
    "description": "Data quality principles, such as accuracy, completeness, and timeliness, reduce risk and support fair processing. Poor data quality can lead to incorrect decisions, regulatory violations, and adverse impacts on data subjects."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Implement data use limitations consistent with stated purposes.",
    "description": "Data should only be used for purposes defined at the time of collection or otherwise permitted by law. Use limitations enforce purpose specification and prevent function creep, secondary misuse, and excessive processing."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Understand privacy implications of data analytics and aggregation.",
    "description": "Analytics techniques, including aggregation and modeling, can reduce identifiability but can also create re-identification risks. Privacy professionals must evaluate anonymization strength, aggregation thresholds, and residual risk."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Recognize governance risks associated with advanced processing environments.",
    "description": "Data warehouses, AI systems, and large-scale analytics platforms often centralize and repurpose data. These environments require strong controls for access, purpose limitation, monitoring, and data minimization to prevent unauthorized or unintended use."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Apply data minimization throughout the data lifecycle.",
    "description": "Data minimization requires collecting only necessary data, limiting its use to defined purposes, retaining it only as long as required, and reducing identifiability where possible. Minimization should be enforced through collection controls, retention schedules, and technical measures such as masking or aggregation."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Differentiate data disclosure, data transfer, and data migration.",
    "description": "Data disclosure involves making data available to another party, often without transferring control. Data transfer refers to moving data between entities or jurisdictions where custody or control might change. Data migration is the movement of data between systems, typically within an organization, often for modernization or consolidation purposes."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Establish retention schedules based on legal, regulatory, and business requirements.",
    "description": "Organizations should define retention periods for each data category, balancing operational needs with regulatory obligations and privacy principles. Retention schedules should be documented, consistently applied, and periodically reviewed."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Implement secure data storage and archiving controls.",
    "description": "Persistent data must be protected through access controls, encryption, integrity mechanisms, and monitoring. Archived data requires equivalent protections, even when stored offline or in lower-cost storage tiers."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Ensure cross-border data transfers comply with applicable requirements.",
    "description": "Transfers across jurisdictions can require safeguards such as contractual clauses, adequacy determinations, or other approved mechanisms. Organizations must assess applicable legal restrictions and ensure appropriate controls are in place before transferring personal data."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Use appropriate data destruction methods for media type and sensitivity.",
    "description": "Logical destruction methods include cryptographic erasure and secure overwrite. Physical destruction methods include shredding, degaussing, drilling, or incineration. The selected method should render data unrecoverable based on risk level."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Document and verify destruction activities.",
    "description": "Organizations should maintain records of destruction, including scope, method, and authorization. Verification steps, such as certificates of destruction or audit sampling, assure that retention limits and privacy requirements are enforced."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Understand how infrastructure choices affect privacy risk.",
    "description": "Legacy systems, on-premises environments, and cloud platforms differ in data visibility, logging capability, encryption options, and control boundaries. Privacy engineering must evaluate how infrastructure architecture influences data protection, residency, isolation, and monitoring capabilities."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Recognize privacy implications of devices and endpoints.",
    "description": "Endpoints such as laptops, mobile devices, IoT systems, and operational technology often collect, cache, store, or transmit personal data. Privacy engineering requires controls such as endpoint encryption, event monitoring, local data minimization, secure configuration, and lifecycle management."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Account for connectivity as a privacy exposure surface.",
    "description": "Networks, APIs, wireless communications, and inter-system integrations create pathways for the movement of personal data. Privacy engineering must address secure transmission, segmentation, in-transit encryption, and monitoring of data flows across connectivity layers."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Integrate privacy into the systems development lifecycle (SDLC).",
    "description": "Privacy requirements should be defined during design, validated during development, and tested before deployment. Activities include data flow mapping, privacy threat modeling, privacy-bydesign principles, and verification of data minimization and retention controls."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Evaluate APIs as controlled interfaces for the exchange of personal data.",
    "description": "APIs frequently expose personal data to external partners and other services. Privacy engineering must enforce authentication, authorization, rate limiting, data filtering, schema validation, and logging to reduce overexposure of personal data."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Understand privacy risks in cloud-native architectures.",
    "description": "Microservices, containers, serverless functions, and orchestration platforms distribute data processing across components. Privacy engineering must ensure consistent enforcement of encryption, identity management, secrets handling, and data governance across services."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Ensure consistency of privacy controls across the entire technology stack.",
    "description": "Privacy engineering requires coordinated controls across infrastructure, endpoints, networks, development practices, and service interfaces to prevent gaps through which personal data could be exposed or processed beyond defined purposes."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Understand the role of asset management in privacy engineering.",
    "description": "Asset inventories identify systems, applications, and data repositories that process personal data. Accurate classification and ownership assignment enable organizations to apply appropriate privacy safeguards, enforce retention requirements, and reduce unauthorized data exposure."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Recognize how identity and access management (IAM) protects personal data.",
    "description": "IAM enforces authentication, authorization, and least-privilege access to systems containing personal data. Role-based and attribute-based controls help ensure that only authorized individuals can view, modify, or transfer personal information. Privileged access management controls protect high-risk privileged administrative and service accounts."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Apply patch management and system hardening to reduce privacy risk.",
    "description": "Timely patching and secure configuration minimize exploitable vulnerabilities that could lead to unauthorized disclosure of personal data. Hardening removes unnecessary services, enforces baseline configurations, and reduces the attack surface of privacy-relevant systems."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Understand the importance of secure communication and transport protocols.",
    "description": "Protocols such as TLS, HTTPS, and secure VPNs protect personal data during transmission. Secure transport prevents interception, tampering, and unauthorized access when data moves between systems, users, or organizations."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Distinguish between encryption and hashing for privacy protection.",
    "description": "Encryption protects confidentiality by transforming data into unreadable form that can be reversed with a key, while hashing provides integrity and non-reversible transformation. Both techniques support privacy by safeguarding stored and transmitted personal data."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Recognize the role of monitoring and logging in privacy assurance.",
    "description": "Logging captures access and processing activities involving personal data. Continuous monitoring enables detection of unauthorized access, supports incident response, and provides audit trails for compliance and accountability."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Integrate security controls into privacy engineering processes.",
    "description": "Privacy-related controls should be applied throughout system design and operation. Coordinated implementation of asset management, IAM, encryption, and monitoring supports privacy-by-design principles and reduces risk across the data lifecycle."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Understand consent tagging and its purpose.",
    "description": "Consent tagging assigns metadata to personal data indicating the scope, purpose, and status of user consent. This enables systems to enforce permitted uses, support withdrawal of consent, and provide audit evidence for regulatory compliance."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Recognize the privacy implications of tracking technologies.",
    "description": "Tracking technologies such as cookies, device fingerprints, and beacons collect behavioral data that can be used to identify individuals or profiles. Privacy controls include notice, consent management, purpose limitation, and mechanisms for opt-out or preference management."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Distinguish anonymization from pseudonymization.",
    "description": "Anonymization irreversibly removes identifiers so individuals cannot be re-identified, whereas pseudonymization replaces identifiers with tokens while retaining the ability to relink data under controlled conditions. Pseudonymized data remains subject to privacy regulations."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Identify common privacy-enhancing technologies (PETs).",
    "description": "PETs include techniques such as differential privacy, federated learning, homomorphic encryption, trusted execution environments, and synthetic data. These technologies enable analysis while minimizing exposure of personal information."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Understand trade-offs when selecting PETs.",
    "description": "PET selection requires balancing privacy protection, data utility, performance overhead, implementation complexity, and scalability. No single PET eliminates risk, and governance controls must complement technical measures. All measures must comply with applicable regulations."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Recognize AI/ML-specific privacy risks.",
    "description": "AI systems introduce re-identification risk, model inversion, membership inference, and unintended memorization of sensitive data. These risks can persist even when training data is anonymized."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Apply privacy-by-design principles to AI/ML use.",
    "description": "Privacy controls for AI include data minimization, consent management, secure training practices, output limitation, differential privacy, and testing for leakage. These measures reduce the likelihood of exposing personal data through model behavior."
  }
];
